
export default function Hero() {
  const handleCallNow = () => {
    window.location.href = 'tel:+14384081200';
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20team%20in%20modern%20bright%20home%20and%20office%20environment%20with%20cleaning%20equipment%20and%20supplies%2C%20natural%20lighting%2C%20clean%20minimalist%20background%20with%20blue%20and%20white%20color%20scheme%2C%20professional%20atmosphere%2C%20high%20quality%20photography%2C%20commercial%20cleaning%20concept%2C%20sparkling%20clean%20surfaces%20and%20windows%2C%20team%20collaboration%2C%20quality%20service%20delivery&width=1920&height=1080&seq=hero-main-updated&orientation=landscape')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
          Votre Partenaire de Confiance
          <br />
          <span className="text-blue-400">pour Tous Vos Services</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
          Entretien ménager résidentiel et commercial, nettoyage de vêtements, 
          repassage à domicile, courses personnalisées et livraison express
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={handleCallNow}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Appelez Maintenant
          </button>
          <button 
            onClick={scrollToContact}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calculator-line mr-2"></i>
            Devis Gratuit
          </button>
        </div>
        
        {/* Services principaux en grille */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-4-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Entretien Résidentiel</h3>
            <p className="text-gray-200 text-sm">Ménage complet à domicile</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-2-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Nettoyage Commercial</h3>
            <p className="text-gray-200 text-sm">Bureaux et espaces pro</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shirt-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Lessive & Repassage</h3>
            <p className="text-gray-200 text-sm">Service à domicile</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-all">
            <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shopping-cart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Courses & Livraison</h3>
            <p className="text-gray-200 text-sm">Pour particuliers et pro</p>
          </div>
        </div>

        {/* Garanties qualité */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">100% Fiable</h3>
            <p className="text-gray-200">Personnel formé et assuré</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">  
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">Service Rapide</h3>
            <p className="text-gray-200">Intervention sous 24h</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">Qualité Premium</h3>
            <p className="text-gray-200">Satisfaction garantie</p>
          </div>
        </div>
      </div>
    </section>
  );
}
